const language: { title: string; value: string }[] = [
    { title: 'English',value: 'English' },
    { title: 'عربي',value: 'Arabic' },
    { title: 'اردو',value: 'Urdu' },
    { title: 'Français',value: 'Français' },
  ];
  export default language;